import { ImageSquare } from '@phosphor-icons/react';

export default ImageSquare;
